
import { Week } from "../types/workout-types";
import { useParams } from "react-router-dom";
import { useRealtimeWorkoutData } from "./useRealtimeWorkoutData";
import { useWorkoutNavigationState } from "./useWorkoutNavigationState";
import { useWorkoutHistoryState } from "./useWorkoutHistoryState";

export function useWorkoutState() {
  const { id: programId } = useParams();
  
  // Get real-time data from Supabase
  const {
    weeks,
    setWeeks,
    loading,
    dataReceived,
    waitingForData
  } = useRealtimeWorkoutData({ programId });
  
  // Get navigation state
  const {
    currentWeekIndex,
    setCurrentWeekIndex,
    currentDayIndex,
    setCurrentDayIndex,
    activeCell,
    setActiveCell,
    editMode,
    setEditMode,
    tempValue,
    setTempValue,
    forceRender,
    setForceRender
  } = useWorkoutNavigationState();
  
  // Get history state
  const {
    history,
    setHistory,
    redoStack,
    setRedoStack,
    isUndoRedo,
    setIsUndoRedo,
    hasEdited,
    setHasEdited
  } = useWorkoutHistoryState();

  const currentWeek = weeks[currentWeekIndex];

  return {
    weeks,
    setWeeks,
    currentWeekIndex,
    setCurrentWeekIndex,
    currentDayIndex,
    setCurrentDayIndex,
    currentWeek,
    loading,
    activeCell,
    setActiveCell,
    editMode,
    setEditMode,
    tempValue,
    setTempValue,
    hasEdited,
    setHasEdited,
    history,
    setHistory,
    redoStack,
    setRedoStack,
    isUndoRedo,
    setIsUndoRedo,
    forceRender,
    setForceRender,
    dataReceived,
    waitingForData
  };
}
